import { apiFetch } from "../useApi";

export default async function getIMessagesStatistic() {
  const response = await apiFetch(`/campaigns/imessages/statistic`);
  return response.json();
}
